import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CategoryContent } from 'src/app/models/category_content-model';
import { environment } from "src/environments/enviroment.prod";
export interface CategoryContentState extends EntityState<CategoryContent> {
  finalProductId?: number; // Add finalProductId to the state
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'categoryContent' })
export class CategoryContentStore extends EntityStore<CategoryContentState, CategoryContent> {
  constructor(private http: HttpClient) {
    super();
  }

  // Method to fetch data with a query and manage it based on finalProductId
  fetchAndStoreCategoryContent(finalProductId: number, queryParams: string): Observable<{ data: CategoryContent[] }> {
    this.setLoading(true); // Indicate loading state

    // If data does not exist, make an HTTP request to fetch data
    return this.http.get<{ data: CategoryContent[] }>(`${environment.apiLink}/final_product/${queryParams}/category_content`)
      .pipe(
        tap(response => {
          this.setLoading(false);
          console.log('response', response)
          // Assign finalProductId to each entity before storing.
          // Spread rather than re-listing the constructor arguments: the
          // positional call stopped at additional_image and silently dropped
          // every column added after it (pdf_design_image,
          // pdf_additives_enabled), so the PDF never saw them.
          const dataWithFinalProductId: CategoryContent[] = response.data.map(content => ({
            ...content,
            finalProductId,
            sosource: '4000',
            disabled: false
          }));


          console.log('data in query', dataWithFinalProductId);

          // Store the data in the store with the finalProductId
          this.upsertMany(dataWithFinalProductId);
        })
      );
  }

}
